import { InjectionToken } from '@angular/core';

/** Simlab office contact shown when the AI assistant is not enabled for the user or the tokens are used up. */
export const AI_AGENT_ACCESS_CONTACT_EMAIL = new InjectionToken<string>('AI_AGENT_ACCESS_CONTACT_EMAIL');
